import { connect } from "react-redux";
import React from "react";
import * as Yup from "yup";

import { authChallengeRequest } from "../../redux/actions/auth";
import Button from "../UI/Button";
import { CustomForm } from "../../component-library/CustomForm";
import FormikInput from "../UI/FormikInput";
import { yup_password_factory } from "../../utils/yupSchemaUtils";

import { AuthWrapper } from "./index";

const validation = Yup.object().shape({
  ConfirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("NEW_PASSWORD"), null], "Password does not match"),
  NEW_PASSWORD: yup_password_factory(),
});

const AuthChallenge = (props) => {
  let setNewPasswordHandler = (form, actions) => {
    let formCopy = Object.assign({}, form);

    delete formCopy["ConfirmPassword"];
    formCopy["USERNAME"] = props.username;
    formCopy["Session"] = props.session;
    props.authChallengeRequest(formCopy);
  };

  return (
    <AuthWrapper showBackLink={true}>
      <section className="ResetPassword">
        <CustomForm
          initialValues={{ ConfirmPassword: "", NEW_PASSWORD: "" }}
          onSubmit={setNewPasswordHandler}
          render={(formikProps) => (
            <form onSubmit={formikProps.handleSubmit}>
              <FormikInput
                errors={formikProps.errors}
                formEl={{
                  elementConfig: {
                    label: "New Password",
                    placeholder: "Enter new password",
                    type: "password",
                  },
                  elementType: "input",
                  name: "NEW_PASSWORD",
                }}
                touched={formikProps.touched}
              />
              <FormikInput
                errors={formikProps.errors}
                formEl={{
                  elementConfig: {
                    label: "Confirm New Password",
                    placeholder: "Confirm New Password",
                    type: "password",
                  },
                  elementType: "input",
                  name: "ConfirmPassword",
                }}
                touched={formikProps.touched}
              />
              <div className="ResetPassword__submit-btn-wpr d-flex tw:justify-center">
                <Button
                  className="Btn Btn--pri Btn-sm mt-5"
                  disabled={formikProps.isSubmitting}
                  type="submit"
                >
                  Change Password
                </Button>
              </div>
            </form>
          )}
          validationSchema={validation}
        />
      </section>
    </AuthWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.auth.session,
    username: state.auth.username,
  };
};

export default connect(mapStateToProps, { authChallengeRequest })(AuthChallenge);
